import BaseComponent from "@js/components/base_component.jsx";

import { Modal, ModalHeader, ModalBody, ModalFooter, ModalButton } from "@js/components/eui/modal/index.js";

class EuiLinkReplacementsForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      match_type: props.entity.match_type,
      expiration_time_do: props.entity.expiration_time_do,
      replacement_includes_capture_refs: props.entity.replacement_includes_capture_refs,
      replacement_do: props.entity.replacement_do,
    };
  }

  render() {
    return (
      <div>

        <ErrorBanner entity={ this.props.entity } />

        <Panel heading="basic_settings">
          <div className="form-horizontal">

            <SelectField
              field="link_replacement.mailclass_id"
              blank="all_mailclasses"
              value={ this.props.entity.mailclass_id }
              options={ this.props.library.mail_classes }
              editing={ this.props.editing }
              error={ this.props.entity.errors ? this.props.entity.errors.mailclass_id : null }
            />

            <InputField
              object={ this.props.entity }
              type="link_replacement"
              field="instanceid"
              editing={ this.props.editing }
            />

            <InputField
              object={ this.props.entity }
              type="link_replacement"
              field="notes"
              editing={ this.props.editing }
              multiline={ true }
            />

          </div>
        </Panel>

        <Panel heading="link_replacement_match">
          <div className="form-horizontal">

            <SelectField
              field="link_replacement.match_type"
              blank={ null }
              value={ this.props.entity.match_type }
              options={ this._matchTypeOptions() }
              editing={ this.props.editing }
              error={ this.props.entity.errors ? this.props.entity.errors.match_type : null }
              onChange={ this._matchTypeChanged }
            />

            {
              ( this.state.match_type === "regexp" || this.state.match_type === "exact" ) && (
                <InputField
                  object={ this.props.entity }
                  type="link_replacement"
                  field="match_string"
                  editing={ this.props.editing }
                />
              )
            }

            {
              ( this.state.match_type === "linkid" ) && (
                <InputField
                  object={ this.props.entity }
                  type="link_replacement"
                  field="linkid"
                  editing={ this.props.editing }
                />
              )
            }

          </div>
        </Panel>

        <Panel heading="link_replacement_rewrite">
          <div className="form-horizontal">

            <CheckboxField
              name="link_replacement[replacement_do]"
              label={ I18n.t("simple_form.labels.link_replacement.replacement_do") }
              editing={ this.props.editing }
              checked={ this.state.replacement_do }
              onChange={ val => this.setState({ replacement_do: val }) }
            />

            {
              this.state.replacement_do && (
                <React.Fragment>
                  <InputField
                    object={ this.props.entity }
                    type="link_replacement"
                    field="replacement_string"
                    editing={ this.props.editing }
                  />

                  {
                    ( this.state.match_type === "regexp" ) && (
                      <CheckboxField
                        name="link_replacement[replacement_includes_capture_refs]"
                        label={ I18n.t("simple_form.labels.link_replacement.replacement_includes_capture_refs") }
                        editing={ this.props.editing }
                        checked={ this.state.replacement_includes_capture_refs }
                        onChange={ val => this.setState({ replacement_includes_capture_refs: val }) }
                      />
                    )
                  }
                </React.Fragment>
              )
            }

          </div>
        </Panel>

        <Panel heading="link_replacement_expiration">
          <div className="form-horizontal">

          <CheckboxField
            name="link_replacement[expiration_time_do]"
            label={ I18n.t("simple_form.labels.link_replacement.expiration_time_do") }
            editing={ this.props.editing }
            checked={ this.state.expiration_time_do }
            onChange={ val => this.setState({ expiration_time_do: val }) }
          />

          {
            this.state.expiration_time_do && (
              <InputField
                object={ this.props.entity }
                type="link_replacement"
                field="expiration_time"
                editing={ this.props.editing }
                helpRawHtml={ I18n.t("simple_form.hints.link_replacement.expiration_time_html") }
              />
            )
          }

          </div>
        </Panel>

      </div>
    );
  }

  _matchTypeOptions() {
    return [
      "all",
      "regexp",
      "exact",
      "linkid",
    ].map((opt) => ({ label: I18n.t(`link_replacement_match_types.${opt}`), value: opt }));
  }

  _matchTypeChanged(e) {
    this.setState({ match_type: e.target.value });
  }

}

export default EuiLinkReplacementsForm;
